// extracted by mini-css-extract-plugin
export default {"breadcrumb":"pk-z","breadcrumbItem":"qk-z"};